import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import { ChakraProvider } from "@chakra-ui/react";
import Amplify from "aws-amplify";

import {
  theme,
  GlobalStyles
} from "./components/theme";
import { AppRouter } from "./pages";
import { AuthProvider } from "./contexts/AuthContext";
import "antd/dist/antd.css";

Amplify.configure({
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_S3_BUCKET,
      region: process.env.REACT_APP_S3_REGION,
      customPrefix: {
        public: "public/",
        protected: "protected/",
        private: "private/"
      }
    }
  },
  Auth: {
    // (required)- Amazon Cognito Region
    region: process.env.REACT_APP_COGNITO_REGION,
    // (required) only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    // (optional) - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    // (optional) - Amazon Cognito Web Client ID (26-char alphanumeric string, App client secret needs to be disabled)
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT,
    // (optional) - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: "USER_PASSWORD_AUTH"
  }
});

// wrap app with context providers
const ReactRoot: React.ReactElement = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <ChakraProvider>
        <AuthProvider>
          <GlobalStyles />

          <AppRouter />
        </AuthProvider>
      </ChakraProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// attach React app to DOM
ReactDOM.render(
  ReactRoot,
  document.getElementById("root")
);
